export default __webpack_public_path__ + "static/media/icon-close-white.0de4bb43.svg";